import { useCallback, useLayoutEffect, useRef } from "react";
import emailDomains from "../constants/email-domains";

export const useEmailAutocomplete = (
    elementId: string,
    setValue: (val: string) => void
) => {
    const prevEmail = useRef<string>("");
    const prevValue = useRef<string>("");
    const email = useRef<string>("");
    const input = useRef<HTMLInputElement>();
    const domains = emailDomains || [];

    const findInput = useCallback((element) => {
        if (element && element.tagName === "INPUT") return element;
        if (element && element.children && element.children.length > 0) {
            element.children.forEach((child: HTMLElement) => {
                const potentialInput = findInput(child);
                if (potentialInput) return potentialInput;
                return "";
            });
        }
        return "";
    }, []);

    useLayoutEffect(() => {
        const element = document.getElementById(elementId);
        input.current = findInput(element);
    }, [findInput, elementId]);

    const suggest = useCallback(
        (emailSuggestion) => {
            const [, partialDomain] = emailSuggestion.split("@");
            if (
                !partialDomain ||
                emailSuggestion.length <= prevValue.current.length
            )
                return "";
            const domain =
                domains.find((d) => d.indexOf(partialDomain) === 0) || "";
            return domain.replace(partialDomain, "");
        },
        [domains]
    );

    const highlight = (suggestion: string) => {
        setTimeout(() => {
            const emailSuggestion = `${prevValue.current}${suggestion}`;
            const startPosition = emailSuggestion.lastIndexOf(suggestion);
            const endPosition = startPosition + suggestion.length;
            input.current.setSelectionRange(startPosition, endPosition);
        }, 0);
    };

    const handleChangeEmail = useCallback(
        (event) => {
            const { value } = event.target;
            const suggestion = suggest(value);
            const theEmail = `${value}${suggestion}`;
            email.current = theEmail;
            if (suggestion) highlight(suggestion);
            prevEmail.current = theEmail;
            prevValue.current = value;
            setValue(email.current);
        },
        [elementId, setValue, suggest]
    );

    const handleKeyDownEmail = useCallback((event) => {
        const { keyCode } = event;
        if (keyCode === 13 || keyCode === 9) {
            input.current.setSelectionRange(
                email.current.length,
                email.current.length
            );
            input.current.blur();
        }
    }, []);
    return {
        handleChangeEmail,
        handleKeyDownEmail,
    };
};
